//import AppForm from '../app-components/Form/AppForm';

//var userLanguage = document.documentElement.lang;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('employee-documents', {

    props: {
        'contracts':{
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'documentGroups':{
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'companyDocumentTypes':{
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'currentContractId': {
            //type: Number,
            required: false,
            default: function() {
                return null;
            }
        },
        'actionGenerate':    {
            type: String,
            required: true
        },
        'actionDownloadSelected':    {
            type: String,
            required: true
        },
        'actionDownloadSelectedPdf':    {
            type: String,
            required: true
        },
        'zipPrefix':    {
            type: String,
            required: false,
            default: function() {
                return "";
            }
        },

    },
    data: function() {
        return {
            mutableCurrentContractId: this.currentContractId,
            mutableContracts: this.contracts,
            currentGroup: null,
            currentContract: null,
            currentDocumentTypes: [],
            selectedDocumentsIds: [],
            selectedAllDocuments: false,
            documentTypes: [],
            submiting: false,
            activeDocumentId: null,
            activeDocumentUrl: null,
        }
    },

    created: function created() {
        this.mutableCurrentContractId = this.currentContractId;
        this.setCurrentContract();
    },

    methods: {
        showModal(documentId, url) {
            this.activeDocumentUrl = url;
            this.activeDocumentId = documentId;
            this.$modal.show('delete-employee-document-form');
        },

        setCurrentContract() {

            this.currentContract = this.getCurrentContract();

            this.setDocumentTypes();
        },

        getCurrentContract(){
            let currentContractId = this.mutableCurrentContractId;
            let currentContract = null;
            if (currentContractId){
                currentContract = this.mutableContracts.filter(function(ele){
                    return (ele.id == currentContractId)
                });
            }
            if (currentContract && currentContract.length){
                currentContract = currentContract[0];
            }
            return currentContract;
        },

        setDocumentTypes(){
            let _this = this;

            this.documentTypes = _this.companyDocumentTypes;

            // templates available in selected document group
            if (_this.currentGroup){
                this.currentDocumentTypes = _this.documentTypes.filter(function(docType){
                    return _this.currentGroup.document_types.some(dt => dt.id === docType.id);
                });
            }
        },

        generatePDF(){
            let _this = this;

            if (_this.currentDocumentTypes.length && _this.currentContract){
                let data ={
                    employee_contract_id: _this.currentContract.id,
                    document_types_ids: _this.currentDocumentTypes.map(function(doc) {return doc.id})
                }
                _this.submiting = true;

                axios.post(_this.actionGenerate, data).then(function (response) {
                    return _this.onSuccess(response.data);
                }).catch(function (errors) {
                    if(errors.response.status !== 422) { // only on diff response codes, because 422 is handled later in this.onFail processing
                        this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.server_error });
                    }

                    _this.errors.add({
                        field: "document_types_ids",
                        msg: errors.response.data.errors.document_types_ids[0]
                    });

                    return _this.onFail(errors.response.data.errors);
                });
            }
        },

        onSuccess(data) {
            let _this = this;

            this.submiting = false;
            if(data.wasAnyDocumentGenerated){
                this.$notify({ type: 'success', title: '<span class="fa fa-check"></span>', text: data.message });
            }

            _this.errors.clear();

            _this.errors.add({
                field: "warning",
                msg: data.warning
            });

            this.currentContract.documents = data.documents;
        },

        onFail: function onFail(errors) {
            this.submiting = false;
        },


        toggleAllDocuments(){
            if (this.selectedAllDocuments){
                this.selectedDocumentsIds = [];
            }else{
                this.selectedDocumentsIds = this.currentContract.documents.map(function(doc) {return doc.id});
            }
            this.selectedAllDocuments = !this.selectedAllDocuments;
        },

        downloadSelectedDocuments(){
            var _this = this;

            if (_this.selectedDocumentsIds.length){
                var data ={
                    document_ids: _this.selectedDocumentsIds
                }
                _this.submiting = true;
                axios({
                    method: 'post',
                    url: _this.actionDownloadSelected,
                    responseType: 'arraybuffer',
                    data: data
                }).then(function(response) {
                    let blob = new Blob([response.data], { type: 'application/zip' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = _this.zipPrefix+"-"+_moment().format('YYYY-MM-DD-HH-mm')+'.zip';
                    link.click();
                    _this.submiting = false;
                }).catch(function (errors) {
                    _this.submiting = false;
                    this.$notify({ type: 'error', title: '<span class="fa fa-exclamation-triangle"></span>', text: errors.response.statusText });
                });


                /*

                axios.post(_this.actionDownloadSelected, data).then(function (response) {
                    return _this.onSuccess(response.data);
                }).catch(function (errors) {
                    return _this.onFail(errors.response.data.errors);
               }); */
            }
        },
        downloadSelectedDocumentsAsPdfmerge(){
            var _this = this;

            if (_this.selectedDocumentsIds.length){
                var data ={
                    document_ids: _this.selectedDocumentsIds
                }
                _this.submiting = true;
                axios({
                    method: 'post',
                    url: _this.actionDownloadSelectedPdf,
                    responseType: 'arraybuffer',
                    data: data
                }).then(function(response) {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = _this.zipPrefix+"-"+_moment().format('YYYY-MM-DD-HH-mm')+'.pdf';
                    link.click();
                    _this.submiting = false;
                }).catch(function (errors) {
                    _this.submiting = false;
                    this.$notify({ type: 'error', title: '<span class="fa fa-exclamation-triangle"></span>', text: 'aa' });
                });
            }
        }
    },

    filters: {
        date: function date(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

            var date = (0, _moment2.default)(date);
            return date.isValid() ? date.format(format) : "";
        },

    },
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeDocuments.js